import request from '@/utils/request';

const baseURL = process.env.VUE_APP_API;

// 保存文件夹
const saveFile = data =>
  request({
    url: `${baseURL}/api/File/SaveFile`,
    method: 'post',
    data
  });

// 查找文件夹及文件列表
const findFile = data =>
  request({
    url: `${baseURL}/api/File/FindFile`,
    method: 'post',
    data
  });

// 设置是否公开
const setFileIsNoAuth = data =>
  request({
    url: `${baseURL}/api/File/SetFileIsNoAuth`,
    method: 'post',
    data
  });

// 获取公开地址
const getFileIsNoAuthUrl = data =>
  request({
    url: `${baseURL}/api/File/GetFileIsNoAuthUrl`,
    method: 'post',
    data
  });

// 查找文件列表详情
const findFileDetail = data =>
  request({
    url: `${baseURL}/api/File/FindFileDetail`,
    method: 'post',
    data
  });

// 移动文件
const moveFile = data =>
  request({
    url: `${baseURL}/api/File/MoveFile`,
    method: 'post',
    data
  });

// 保存重命名
const renameFile = data =>
  request({
    url: `${baseURL}/api/File/RenameFile`,
    method: 'post',
    data
  });

// 复制文件
const copyFile = data =>
  request({
    url: `${baseURL}/api/File/CopyFile`,
    method: 'post',
    data
  });

// 删除文件
const deleteFile = data =>
  request({
    url: `${baseURL}/api/File/DeleteFile`,
    method: 'post',
    data
  });

// 后台删除文件
const adminDelRecycleBinFile = data =>
  request({
    url: `${baseURL}/api/File/AdminDelRecycleBinFile`,
    method: 'post',
    data
  });

// 查找回收站文件
const findRecycleBin = data =>
  request({
    url: `${baseURL}/api/File/FindRecycleBin`,
    method: 'post',
    data
  });

// 恢复回收站文件
const recoverFile = data =>
  request({
    url: `${baseURL}/api/File/RecoverFile`,
    method: 'post',
    data
  });

// 获取在线预览地址
const findPreviewUrl = data =>
  request({
    url: `${baseURL}/api/File/FindPreviewUrl`,
    method: 'post',
    data
  });

// 判断是否能进入分享链接
const checkFileUrl = data =>
  request({
    url: `${baseURL}/api/File/CheckFileUrl`,
    method: 'post',
    data
  });

// 判断是否有权限上传
const checkFileUpdate = data =>
  request({
    url: `${baseURL}/api/File/CheckFileUpdate`,
    method: 'post',
    data
  });

// 保存分享时间
const saveShareLimit = data =>
  request({
    url: `${baseURL}/api/File/SaveShareLimit`,
    method: 'post',
    data
  });

// 最近访问，我的收藏，检查是否能打开权限
const checkFileOpen = data =>
  request({
    url: `${baseURL}/api/File/CheckFileOpen`,
    method: 'post',
    data
  });

// 前端调上传保存文件及文件夹
const frontSaveFile = data =>
  request({
    url: `${baseURL}/api/File/FrontSaveFile`,
    method: 'post',
    data
  });

// 前端调上传保存文件及文件夹
const saveVersion = query =>
  request({
    url: `${baseURL}/api/File/SaveVersion`,
    method: 'post',
    params: query
  });

const checkOssFile = data =>
  request({
    url: `${baseURL}/api/File/CheckOssFile`,
    method: 'post',
    data
  });

// 获取下载URL链接（不用token)
const getDownloadUrlById = data =>
  request({
    url: `${baseURL}/api/File/GetDownloadUrlById`,
    method: 'post',
    data
  });

// 获取公开文件夹列表（不用token）
const findFileNoAuth = data =>
  request({
    url: `${baseURL}/api/File/FindFileNoAuth`,
    method: 'post',
    data
  });

// 通过fileId获取当前的url
const getUrlByFileId = query =>
  request({
    url: `${baseURL}/api/File/GetUrlByFileId`,
    method: 'post',
    params: query
  });

// 通过fileId获取当前路径下的每一级的url和fileId
const findUrlAndFileId = params =>
  request({
    url: `${baseURL}/api/File/FindUrlAndFileId`,
    method: 'get',
    params
  });

// 根据子文件夹id查找父文件id
const getParentFileId = params =>
  request({
    url: `${baseURL}/api/File/GetParentFileId`,
    method: 'get',
    params
  });

// 查询分享列表
const findShareLine = data =>
  request({
    url: `${baseURL}/api/File/FindShareLine`,
    method: 'post',
    data
  });
// 将分享链接启用或关闭
const setIsLost = data =>
  request({
    url: `${baseURL}/api/File/SetIsLost`,
    method: 'post',
    data
  });
// 查询分享列表（可搜索访问人）
const findShareLineLogin = data =>
  request({
    url: `${baseURL}/api/File/FindShareLineLogin`,
    method: 'post',
    data
  });
// 获取分享链接的原路径
const getShareUrl = params =>
  request({
    url: `${baseURL}/api/File/GetShareUrl`,
    method: 'get',
    params
  });
// 保存引用
const saveLinkFileBatch = data =>
  request({
    url: `${baseURL}/api/File/SaveLinkFileBatch`,
    method: 'post',
    data
  });
// 删除引用
const deleLinkFileBatch = data =>
  request({
    url: `${baseURL}/api/File/DeleLinkFileBatch`,
    method: 'post',
    data
  });

export default {
  saveFile,
  findFile,
  setFileIsNoAuth,
  getFileIsNoAuthUrl,
  findFileDetail,
  moveFile,
  renameFile,
  copyFile,
  deleteFile,
  adminDelRecycleBinFile,
  findRecycleBin,
  recoverFile,
  findPreviewUrl,
  checkFileUrl,
  checkFileUpdate,
  saveShareLimit,
  checkFileOpen,
  frontSaveFile,
  saveVersion,
  checkOssFile,

  getDownloadUrlById,
  findFileNoAuth,
  getUrlByFileId,
  findUrlAndFileId,
  getParentFileId,

  findShareLine,
  setIsLost,
  findShareLineLogin,
  getShareUrl,

  saveLinkFileBatch,
  deleLinkFileBatch
};
